import { Segment } from "semantic-ui-react";
import { DomainTaskTitle } from "./DomainTaskTitleComponent";
import ComingSoonPlaceholder from '../../Assessment/ComingSoonPlaceholder'
import styles from "./DomainTasks.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";

export const SpiritualDomainTask1 = (questionCompleter: any) => {
  return {
    header: "Capturing your Older Adult's Story ",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgScaleDownHeight}`} style={{ backgroundImage: `url(${cdnRoute}SharingExperiences.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Experts have developed reminiscence and life-review approaches specifically for older adults to help them find meaning through describing and discussing memories of their life experiences. These approaches can help older adults achieve a sense of meaning and prepare a legacy for after the older adult has passed.
              </p>
              <p >
                Sharing and documenting this information with friends and family members, especially younger ones such as grandchildren, can help to keep the older adult's memories alive for years to come. This can be done through a written account of stories or audio/video recordings of the older adult recounting their life experiences.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask2 = (questionCompleter: any) => {
  return {
    header: "Discussing Funeral Wishes",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgScaleDownHeight} `} style={{ backgroundImage: `url(${cdnRoute}FuneralWishes.jpeg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                It is important to learn about the older adult's wishes and/or plans for their funeral arrangements and document them for future reference. Burial preferences and practices may be influenced by the older adult's spiritual tradition and affiliations.
              </p>
              <p >
                Many checklists and resources are available to help older adults articulate their wishes and plans. You and the older adult may find it helpful to talk with a funeral director or member of the clergy and develop a pre-need plan. This way all wishes are recorded and are easily accessible when they are needed.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask3 = (questionCompleter: any) => {
  return {
    header: "End-of-Life Care",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgShiftLeftSM}`} style={{ backgroundImage: `url(${cdnRoute}EndOfLifeCareLearnMore2.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Most communities provide palliative care and other end-of-life services. Hospice is the most well-known provider for people whose medical conditions have progressed to a point where death is expected within a matter of months. These services are aimed at enhancing the quality of life at the end. They are typically delivered at home, providing support to both the patient and family members. Some programs also have inpatient facilities for when physical care needs cannot be handled by caregivers at home.
              </p>
              <p >
                Many health professionals suggest that healthy older adults talk with their primary care physician about the circumstances under which they would prefer palliative or hospice care to aggressive medical interventions when the end-of-life is close.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask4 = (questionCompleter: any) => {
  return {
    header: "Making Peace with Your Parent",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`} 
            style={{ backgroundImage: `url(${cdnRoute}MakingPeaceLearnMore2.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
              It is not uncommon for adult children or other family members and aging persons to be at odds with one another concerning issues that have been unresolved for many years. The failure to be reconciled can lead to strained relationships, which cause problems for the persons in a caregiving role. 
              </p>
              <p >
              People typically want to be reconciled as their older family members grow older. As it becomes clear that they may soon be separated by death, giving and receiving forgiveness for past issues may become especially important topics.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask5 = (questionCompleter: any) => {
  return {
    header: "Understanding Spiritual Needs And Beliefs",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientVertical} `} 
            style={{ backgroundImage: `url(${cdnRoute}SpiritualNeeds.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
              Research shows that conversations between older adults and family members about spirituality and faith help older adults meet the challenges of late life. Spirituality and religion shape individual, family, and communal relations across the life course. Religious involvement enhances well-being by providing social support, as well as a belief system that can offer hope and a sense of meaning and purpose in life. 
              </p>
              <p >
              Learn about the older adult's religious beliefs and spiritual needs. Encourage and support their beliefs and practices. This can also help to build a stronger relationship between you, the older adult, and other caregivers involved.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask6 = (questionCompleter: any) => {
  return {
    header: "Faith-Based Programs",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientVertical} ${styles.imgShiftLeftXS}`} 
            style={{ backgroundImage: `url(${cdnRoute}Volunteers4.jpeg)`, }}>
          <div className={styles.domainTaskContent} >
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
              Religious organizations comprise the largest single network and the largest untapped source of volunteers to serve the needs of older people. Many of these organizations serve all seniors in their community as well as their own members.
              </p>
              <p >
              Religious institutions are broadening their traditional spiritual support services by offering fellowship, recreation, clothing, food, and financial assistance. Many faith communities also work cooperatively with local social and legal agencies. Using these resources can make a positive impact on the older adult's life.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask7 = (questionCompleter: any) => {
  return {
    header: "Discovering Purpose",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgShiftRightSM}`} style={{ backgroundImage: `url(${cdnRoute}discoveringpurpose_learnmore.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Finding meaning or purpose in late life is sometimes difficult for older adults. Some feel without purpose when they have 
                retired from their employment or raised their children. Yet many elders discover new meaning and purpose in serving others 
                in a voluntary capacity.  
              </p>
              <p >
                Opportunities abound in all settings for meaningful service to others. This can be as simple as finding out what neighbors 
                need (transportation, an occasional meal, someone to visit and talk with) and meeting that need or participating in an 
                organized volunteer activity through one's church or a volunteer organization. You can learn about volunteer opportunities 
                in the older adult's area and brainstorm about which opportunities best fit with their talents and interests.  
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask8 = (questionCompleter: any) => {
  return {
    header: "Prayer with Parents",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}spiritualbeliefs_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Prayer unites generations. In many families, a longstanding tradition of praying together strengthens the relationship between 
                adult children and their older parents or other family members. Where such a tradition is established, it can be a source of 
                strength and comfort to both generations. Where it is not yet established, it is a practice to consider adding to regular 
                visits and telephone calls.  
              </p>
              <p >
                Even if older adults and their family members do not feel comfortable praying together about issues that touch their common 
                lives, they can find strength in praying to God about the older adult's life and their hopes and wishes for the coming days 
                and years.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTask9 = (questionCompleter: any) => {
  return {
    header: "Church Contacts",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}churchcontacts_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                This task is particularly important for family members and caregivers who don't live in the same geographical location as
                the older adult.
              </p>
              <p>
                Worship with the older adult when you visit them and be sure you have all contact information about the church and clergy as 
                well as contact information for several of the older adult's church friends. Introduce yourself to clergy and friends of the 
                older adult if you do not know them well already. 
              </p>
              {/* <p >
                Trained occupational therapists and others can assess home
                Worship with the older adult when you visit them and be sure you
                have all contact information about the church and clergy as well
                as contact information for several of the older adult's church
                friends. Introduce yourself to clergy and friends of the older
                adult if you do not know them well already.
              </p>
              <p >
                With the older adult's permission, such individuals can be
                especially helpful to you in alerting you to changes and issues
                that may arise between your visits with the older adult.
              </p> */}
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const SpiritualDomainTaskPlaceholder = () => {
  return {
    header: "Task Coming Soon",
    content: (
      <ComingSoonPlaceholder />
    ),
  };
};
